export const build = {"tag":"5ab5aff707d19aca4bbe03afbcaad3aa42874930","hash":"5ab5aff7","time":"260506.0534"}